import React, { useCallback } from 'react'
import { FiTrash } from 'react-icons/fi'
import { useSelector } from 'react-redux'

import PropTypes from 'prop-types'

import { Button } from '~/components/Buttons'
import Loading from '~/components/Loading'
import { Spinner } from '~/components/Spinner'
import useConfirmationModal from '~/hooks/useConfirmationModal'

import usePromotion from '../../hooks/usePromotion'

const DeleteButton = ({ promotion, keepsMenuOpen, menuItem = false }) => {
  const [ConfirmationhModal, showConfirmationModal, toggleConfirmationModal] =
    useConfirmationModal()

  const { handleDeletePromotion } = usePromotion()

  const { loadingDelete: loading } = useSelector(state => state.promotional)

  const handleToogle = useCallback(() => {
    keepsMenuOpen && keepsMenuOpen(oldState => !oldState)

    toggleConfirmationModal()
  }, [keepsMenuOpen, toggleConfirmationModal])

  const handleSubmit = useCallback(() => {
    const data = {
      promotion,
      onSuccess: menuItem ? handleToogle : null
    }

    handleDeletePromotion(data)
  }, [promotion, menuItem, handleToogle, handleDeletePromotion])

  return (
    <>
      {menuItem ? (
        <button
          type="button"
          onClick={handleToogle}
          className="danger"
          disabled={loading}
        >
          {loading ? <Spinner /> : <FiTrash />} <span>Excluir</span>
        </button>
      ) : (
        <Button
          text="Excluir"
          type="button"
          template="transparentCritical"
          size="small"
          iconLeft={loading ? <Spinner /> : <FiTrash />}
          customWidth="auto"
          onClick={handleToogle}
        />
      )}

      {/* Modal deletar */}
      <ConfirmationhModal
        title="Deseja excluir a promoção?"
        isOpen={showConfirmationModal}
        onClose={handleToogle}
        onSubmit={handleSubmit}
        confirmationButton="Entendo e desejo excluir esta promoção"
      >
        <p>
          Esta ação não poderá ser desfeita e as ações em decorrência desse ato
          não poderão ser desfeitas.
        </p>
        {loading && <Loading status={loading}>Excluindo promoção...</Loading>}
      </ConfirmationhModal>
    </>
  )
}

export default DeleteButton

DeleteButton.propTypes = {
  promotion: PropTypes.shape({}).isRequired,
  keepsMenuOpen: PropTypes.func,
  menuItem: PropTypes.bool
}

DeleteButton.defaultProps = {
  menuItem: false,
  keepsMenuOpen: null
}
